import * as api from 'utils/api';
export const getSettings = async userId =>
  await api.get('/regulatoryAuthority/' + userId + '/settings');

export const saveSettings = async (userId, settingsData) =>
  await api.put('/regulatoryAuthority/' + userId + '/settings', settingsData);
